import { NavigationRouteType } from '../../context/NavigationContext';

const shouldShowRightPanel = ({ routeType }) => (
  routeType === NavigationRouteType.COACH
);

export default shouldShowRightPanel;
